export class BaseLocation {
    latitude = 0;
    longitude = 0;
    elevation = 0;
}
